// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomLabel__title___ORN96 {
    margin: 0 0 0 1rem;
    line-height: 2.4rem;
}

.CustomLabel__btnContextMenu___IR5Sx {
    margin-left: auto;
    opacity: 0;
}

.CustomLabel__container___wqXSk {
    display: flex;
    align-items: center;
}

.CustomLabel__container___wqXSk:hover .CustomLabel__btnContextMenu___IR5Sx {
    opacity: 1;
}

.CustomLabel__check___yVvTw {
    padding-right: var(--space-xs);
}

.CustomLabel__textTooltip___gnFuK {
    word-wrap: break-word;
}

.CustomLabel__draftElement___DFSZ3 {
    padding-right: 0.1rem;
    font-style: italic;
}

.CustomLabel__tooltipWidth___Un6xP {
    width: 12.7rem;
}

.CustomLabel__wrapper___A0DIV {
    display: flex;
}

.CustomLabel__draftText___VuUL0 {
    padding-top: 1.6rem;
}

.CustomLabel__treeMargin___yeCDF {
    margin-left: 2.4rem;
}

.CustomLabel__icon___X50NL {
    display: flex;
    width: -moz-max-content;
    width: max-content;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ProjectObjects/CustomLabel/CustomLabel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;AACtB","sourcesContent":[".title {\n    margin: 0 0 0 1rem;\n    line-height: 2.4rem;\n}\n\n.btnContextMenu {\n    margin-left: auto;\n    opacity: 0;\n}\n\n.container {\n    display: flex;\n    align-items: center;\n}\n\n.container:hover .btnContextMenu {\n    opacity: 1;\n}\n\n.check {\n    padding-right: var(--space-xs);\n}\n\n.textTooltip {\n    word-wrap: break-word;\n}\n\n.draftElement {\n    padding-right: 0.1rem;\n    font-style: italic;\n}\n\n.tooltipWidth {\n    width: 12.7rem;\n}\n\n.wrapper {\n    display: flex;\n}\n\n.draftText {\n    padding-top: 1.6rem;\n}\n\n.treeMargin {\n    margin-left: 2.4rem;\n}\n\n.icon {\n    display: flex;\n    width: max-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CustomLabel__title___ORN96`,
	"btnContextMenu": `CustomLabel__btnContextMenu___IR5Sx`,
	"container": `CustomLabel__container___wqXSk`,
	"check": `CustomLabel__check___yVvTw`,
	"textTooltip": `CustomLabel__textTooltip___gnFuK`,
	"draftElement": `CustomLabel__draftElement___DFSZ3`,
	"tooltipWidth": `CustomLabel__tooltipWidth___Un6xP`,
	"wrapper": `CustomLabel__wrapper___A0DIV`,
	"draftText": `CustomLabel__draftText___VuUL0`,
	"treeMargin": `CustomLabel__treeMargin___yeCDF`,
	"icon": `CustomLabel__icon___X50NL`
};
export default ___CSS_LOADER_EXPORT___;
